export enum SupplierReportTypes {
    ito = 'ito',
    sra = 'sra',
    sgp = 'sgp',
}